// extracted by mini-css-extract-plugin
export default {"root":"_3pHKQ","flames":"_2OtFK","flame":"_3dyKf"};